<template>
  <res-dialog :showDialog="showDialog"
              :maxWidth="maxWidth"
              :setWidth="setWidth"
              setHeight="100"
              saveButtonColor="resBlue darken-1"
              cancelButtonColor="resBlue darken-1"
              title="Pagination Settings"
              titleClass="resBlue darken-1 white--text"
              :showTitleIcon="false"
              :titleIconSize="17"
              iconColor="white"
              saveButtonText="SAVE"
              cancelButtonText="CANCEL"
              cancelButtonWidth="80"
              :defaultButtonAction="confirm"
              @save="confirm"
              @cancel="cancel">

      <div class="py-8">
        Default number of GL accounts to load on the GL Account group pages
        <div class="short">
          <res-number-input-field ref="pageSizeInput" v-model="pageSize" :minValue="1" :maxValue="100"></res-number-input-field>
        </div>
      </div>

  </res-dialog>
</template>

<script>
  import ResDialog from '@/components/base/ResDialog.vue';
  import ResNumberInputField from '@/components/base/ResNumberInputField.vue';
  import { mapGetters, mapActions } from 'vuex';

  export default {
    components: {
      ResDialog,
      ResNumberInputField
    },
    props: {
      showDialog: {
        type: Boolean
      },
      maxWidth: {
        type: Number
      },
      setWidth: {
        type: Number
      }
    },
    data: function () {
      return {
        pageSize: +(sessionStorage.getItem('budgets-pro-page-size')) || 25
      }
    },
    computed: {
      ...mapGetters(['currentLoading']),
    },
    methods: {
      ...mapActions(['changeLoading']),
      cancel() {
        this.$emit('cancel', true)
      },
      confirm() {
        this.$refs.pageSizeInput.$refs.input.blur();
        this.changeLoading(true);
        setTimeout(() => { this.$emit('confirm', { pageSize: this.pageSize }); }, 750);
      }
    }
  }
</script>

<style scoped lang="scss">
  .short {
    max-width: 150px;
    display: inline-block;
    margin-left: 10px;
    max-height: 30px;
  }
</style>
